import styled from 'styled-components';
import { breakpoints } from 'utils/rwd';

export const Section = styled.section`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
`;

export const Frame = styled.div`
  position: relative;
  display: block;
  width: 100%;
  overflow: hidden;
  border: 1px solid #e3e6e8;
  aspect-ratio: 16 / 6;
  background: #ffffff;
`;

export const PreviewImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  background: #ffffff;
  object-fit: cover;
  object-position: center;
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.75) 0%,
    rgba(0, 0, 0, 0.15) 45%,
    transparent 68%
  );
  pointer-events: none;
`;

export const Content = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  max-width: 60%;
  padding: 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
`;

export const Title = styled.h2`
  display: -webkit-box;
  max-width: 24ch;
  margin: 0;
  overflow: hidden;
  color: #ffffff;
  font-size: 34px;
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

export const Cta = styled.span`
  display: inline-flex;
  padding-bottom: 4px;
  border-bottom: 1px solid #cccccc;
  align-items: center;
  color: #ffffff;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const CtaIcon = styled.span`
  display: inline-flex;
  margin-left: 6px;
`;

export const ResponsivePreview = styled.div`
  display: contents;

  @container customer-preview (max-width: ${breakpoints.sm - 1}px) {
    ${Content} {
      max-width: 80%;
      padding: 20px;
      gap: 10px;
    }

    ${Title} {
      font-size: 22px;
    }

    ${Cta} {
      font-size: 12px;
    }
  }

  @container customer-preview (max-width: ${breakpoints.xs - 1}px) {
    ${Frame} {
      aspect-ratio: 4 / 3;
    }
  }
`;
